<template>
  <div style="width: 700px; margin: 40px auto 0 20px">
    <!-- 第一行：UserID输入框 -->
    <el-form :model="form" label-width="auto" label-position="left">
      <el-form-item label="UserID">
        <el-input
          v-model="form.uuid"
          maxlength="6"
          placeholder="请输入6位纯数字"
          clearable
          @input="onUserIdInput"
        />
      </el-form-item>
      <!-- 第二行：指定绑定人输入框和搜索按钮 -->
      <el-form-item label="指定绑定人（非必填）">
        <div style="display: flex; align-items: center">
          <el-input
            v-model="form.user_id"
            placeholder="请输入指定人的 UUID"
            clearable
            style="flex: 1"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            style="margin-left: 10px"
            @click="searchBindUser"
            >搜索</el-button
          >
        </div>
        <!-- 绑定人名称显示 -->
        <el-card v-if="bindUserName" style="margin-top: 10px; color: #606266">
          绑定人名称：{{ bindUserName }}
        </el-card>
        <div v-if="!bindUserName" style="margin-top: 10px; color: #909399">
          暂无绑定人名称
        </div>
      </el-form-item>
    </el-form>

    <!-- 按钮行 -->
    <div style="text-align: right">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm" v-loading="loading"
        >确认</el-button
      >
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: {
        id: '',
        uuid: '',
        user_id: '',
      },
      loading: false,
      bindUserName: '',
    }
  },
  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.id) {
      this.getlockdetail(this.$route.query.id)
    }
  },
  methods: {
    getlockdetail(id) {
      this.form.id = id
      request({
        url: '/api/backend/uuidLock/detail',
        method: 'get',
        params: {
          id: id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            id: res.data.id,
            uuid: res.data.uuid,
            user_id: res.data.user?.uuid || '',
          }
          if (this.form.user_id) {
            this.searchBindUser()
          }
        }
      })
    },
    onUserIdInput(val) {
      // 只允许输入6位纯数字
      this.form.userId = val.replace(/\D/g, '').slice(0, 6)
    },
    searchBindUser: (() => {
      let timer = null
      return function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.loading = true
          if (this.form.uuid) {
            request({
              url: '/api/backend/users/detail',
              method: 'get',
              params: {
                uuid: this.form.user_id,
              },
            }).then((res) => {
              console.log(res)
              if (res.code == 0 && res.data) {
                this.bindUserName = res.data.username
              } else {
                this.bindUserName = ''
                this.$message.error('未找到该ID对应的用户')
              }
              this.loading = false
            })
          } else {
            this.loading = false
            this.bindUserName = ''
          }
        }, 300)
      }
    })(),
    cancel() {
      // 取消逻辑
      this.form.uuid = ''
      this.form.user_id = ''
      this.bindUserName = ''
      this.$router.back()
    },
    confirm() {
      // 确认逻辑
      // 可以提交表单
      request({
        url: '/api/backend/uuidLock/store',
        method: 'post',
        params: {
          id: this.form.id,
          uuid: this.form.uuid,
          user_id: this.bindUserName ? this.form.user_id : '',
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.$message.success('编辑成功')
          this.$router.back()
        } else {
          this.$message.error(res.message || '编辑失败')
        }
      })
    },
  },
}
</script>

<style scoped></style>
